import { GridDef } from '@/types';
import { sortNumbers } from '@/utilities/sort';

export default function createGrid<T extends GridDef>(forceUpdate: boolean, moduleData: T): T {
  let data = { ...moduleData };

  if (!data.panelsPerRow && !data.rows) {
    data.rows = 2;

    if (data.numberOfPanels! > 20) {
      data.rows = Math.ceil(data.numberOfPanels! / 10);
    }

    data.panelsPerRow = Math.ceil(data.numberOfPanels! / data.rows);

    return data;
  }

  if (!forceUpdate) return moduleData;

  const colMax =
    (data.grid
      ?.map(cell => cell.col)
      .sort(sortNumbers)
      .reverse()[0] ?? 0) + 1;

  const rowMax =
    (data.grid
      ?.map(cell => cell.row)
      .sort(sortNumbers)
      .reverse()[0] ?? 0) + 1;

  data.panelsPerRow = Math.max(colMax, Math.ceil(data.numberOfPanels! / 2));

  if (data.panelsPerRow > 10) {
    data.panelsPerRow = 10;
  }

  data.rows = Math.max(2, rowMax, Math.ceil(data.numberOfPanels! / data.panelsPerRow));

  return data;
}
